import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../../store/serviceUrls";

export const getCollegeRankingFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COLLEGE_RANKING_FILTER_API,
        params: params,
    });
}

export const getCollegeRankingListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COLLEGE_RANKING_LIST,
        params: params,

    });
}

export const postCollegeRankingListRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.POST_COLLEGE_RANKING_LIST,
        data: data,
    });
}

export const getStudyabroadCollegeRankingDetailRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_STUDYABROAD_COLLEGE_RANKING_DETAIL,
        params: params,
    });
}

export const putCollegeRankingDetailUpdateRepo = (data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_STUDYABROAD_COLLEGE_RANKING_DETAIL,
        data:data,
    });
}

export const getCourseRankingListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COURSE_RANKING_LIST,
        params: params,
    });
}

export const postCourseRankingListRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.GET_COURSE_RANKING_LIST,
        data: data,
    });
}

export const getCourseRankingDetailRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COURSE_RANKING_DETAIL,
        params: params,
    });
}

export const putCourseRankingDetailRepo = (data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_COURSE_RANKING_DETAIL,
        data: data,
    });
}

// TO FILTER OUT DUPLICATED COLLEGES
export const getCollegeRankingFilterCollegeRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COLLEGE_RANKING_FILTER_COLLEGE,
        params: params,
    });
}

// TO FILTER OUT DUPLICATE COURSES
export const getCourseRankingFilterCourseRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_COURSE_RANKING_FILTER_COURSES,
        params: params,
    });
}